import "./lastPage.scss";
import React from "react";
import { useNavigate } from "react-router-dom";
import Btton from "../../components/Start-Btn/StartBtn";
import "@fontsource/roboto";
import "@fontsource/roboto/700.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";

const LastPage = () => {
  const navigate = useNavigate();

  return (
    <div className="containor">
      <div className="containor-wrapper">
        <div className="success-icon-container">
          <CheckCircleIcon className="success-checkmark" />
        </div>

        <div className="top" style={{ fontFamily: "Roboto" }}>
          <h1>Submission Successful!</h1>
          <div className="divider" />
          <p className="thank-you-msg">
            Thank you for taking the time to provide your details.
          </p>
          <p className="description">
            We truly appreciate you choosing to share your valuable time with
            us. Our team will promptly review the information you've submitted
            and confirm your booking via email shortly. Thank you again!
          </p>
        </div>

        <div className="timeline-container">
          <h3 className="timeline-title" style={{ fontFamily: "Roboto" }}>What Happens Next?</h3>
          
          <div className="timeline-step done">
            <div className="timeline-icon-wrapper">
              <CheckCircleIcon className="timeline-icon" />
            </div>
            <div className="timeline-content">
              <h4 style={{ fontFamily: "Roboto" }}>1. Details Submitted</h4>
              <p style={{ fontFamily: "Roboto" }}>Your guest information and documents have been securely uploaded.</p>
            </div>
          </div>

          <div className="timeline-step pending">
            <div className="timeline-icon-wrapper">
              <HourglassEmptyIcon className="timeline-icon" />
            </div>
            <div className="timeline-content">
              <h4 style={{ fontFamily: "Roboto" }}>2. Document Verification</h4>
              <p style={{ fontFamily: "Roboto" }}>Our reservations team will verify your Passport/NIC upload.</p>
            </div>
          </div>

          <div className="timeline-step pending">
            <div className="timeline-icon-wrapper">
              <MarkEmailReadIcon className="timeline-icon" />
            </div>
            <div className="timeline-content">
              <h4 style={{ fontFamily: "Roboto" }}>3. Confirmation Email</h4>
              <p style={{ fontFamily: "Roboto" }}>A confirmation email with check-in instructions will be sent shortly.</p>
            </div>
          </div>
        </div>

        <div className="bottom">
          <Btton
            name="Back to Home"
            onClick={() => {
              navigate("/");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LastPage;
